<script setup>
defineOptions({
  inheritAttrs: false,
})
defineProps({
  containerAttrs: {
    type: Object,
    required: false,
    default: undefined,
  }
})

const model = defineModel({
  type: String,
});
</script>

<template>
  <div
    class="tw-flex tw-items-center tw-relative tw-border-2 tw-border-grey-mid tw-rounded-md overflow-hidden"
    v-bind="containerAttrs"
  >
    <slot name="icon" />
    <select
      v-model="model"
      class="tw-pl-3 tw-text-lg tw-pr-12 tw-py-2 tw-w-full tw-appearance-none tw-box-content"
      v-bind="$attrs"
    >
      <slot />
    </select>
    <svg-vue
      icon="icons/chevron"
      class="tw-h-3 tw-w-3 tw-absolute tw-top-[40%] tw-right-4 tw-text-grey"
    />
  </div>
</template>
